<sw-card-header [title]="title" *ngIf="title"></sw-card-header>
<ng-content></ng-content>